import { System } from './../../System';
import { Component, EventEmitter, Output, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tyl-button',
  templateUrl: './tyl-button.component.html',
  styleUrls: [
    './tyl-button.component.css'
  ]
})
export class TylButtonComponent implements OnInit {
  @Input() public image: string;
  @Input() public disabledImage: string;
  @Input() public label: string;
  @Input() public showLabel = true;
  @Input() public disabled = false;
  @Input() public textColor: string;
  @Input() public iconWidth: number;
  @Input() public noPadding = false;
  @Input() public id: string;
  @Output()
  clickEvent = new EventEmitter<string>();
  srcUrl: string;
  private localDisabled = false;  // to prevent double-clicking/ rapid clicks.  This will disallow clicking but won't gray out the button
  toCamelCase: (str: string) => string;

  constructor() {
  }

  ngOnInit() {
    this.toCamelCase = System.toCamelCase;
  }

  onClick() {
    if (!this.disabled && !this.localDisabled) {
      this.localDisabled = true;
      this.clickEvent.emit();

      setTimeout(() => {
        this.localDisabled = false;
      }, 300);
    }
  }

  checkId() {
    if (!!this.id) {
      return this.id;
    } else {
      return this.toCamelCase(this.label) + 'Button';
    }
  }

  onKeydown(event: KeyboardEvent) {
    if ((event.key == 'Enter' || event.key == ' ') && !this.disabled) {
      event.stopPropagation();
      this.clickEvent.emit();
    }
  }
}
